import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    [theme.breakpoints.up('laptop')]: {
      display: 'flex',
      flexDirection: 'column',

      width: '100%',
      height: 'calc(100vh - 160px)',
    },
  },
  sectionWrapper: {
    [theme.breakpoints.up('laptop')]: {
      marginRight: '-70px',

      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      overflowY: 'auto',
    },
  },
  section: {
    maxWidth: 900,
    height: 'inherit',

    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: SPACES.xxl,

    [theme.breakpoints.down('laptop')]: {
      marginBottom: SPACES.xxl,
    },
  },

  sectionTitle: {
    marginBottom: SPACES.xs,

    color: theme.palette.custom.darkBlue2,
    fontSize: FONTS.SIZES.xl,
    fontWeight: FONTS.WEIGHTS.bold,
    lineHeight: 1.38,
  },
}))
